import { useQuery } from "react-query";

import { makeRequest } from "@/util";
import { RolePermissions } from "../types";

export default function usePermissions() {
  return useQuery(
    ["getRolePermissions"],
    async () => {
      const res = await makeRequest<RolePermissions>(
        "get_role_permissions",
        {},
      );
      return res.data;
    },
    { staleTime: Infinity },
  );
}
